module.exports = __webpack_public_path__ + "img/logo_xmiles_top-w.5d649f79.png";